<template>
    <div :class="['help-mod']" v-if="show">
        <div class="help-container">
            <h3>{{ $t("dashboard.help") }}</h3>
            <ul class="contact-button">
                <li class="support">
                    <a :href="getOfficialUrl( config.contact_us )" target="_blank">
                        <span class="icon-co_support help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.contact") }}</p>
                    </a>
                </li>
                <li class="ask" v-if="!FEATURE('help.community')">
                    <a href="https://community.reolink.com/" target="_blank">
                        <span class="icon-co_weeklysummary help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.ask") }}</p>
                    </a>
                </li>
                <li class="facebook">
                    <a :href="config.facebookUrl" target="_blank">
                        <span class="icon-icon_facebook help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.facebook") }}</p>
                    </a>
                </li>
                <li class="twitter">
                    <a :href="config.twitterUrl" target="_blank">
                        <TwitterLogo class="help-icon"/>
                        <p class="help-des">{{ $t("dashboard.twitter") }}</p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { config } from 'CONFIG';
import TwitterLogo from './Svg/TwitterLogo.vue';
export default {
    components: {
        TwitterLogo
    },
    data () {

        return {

            config

        };

    },

    computed: {

        show () {

            return !this.$route.path.includes( '/checkout/' );

        }

    }

};
</script>
<style type="text/css" lang="less" scoped>

    .help-mod {
        background-color: @bg_03;
        padding: 50px 0;
        @media @mobile{
            padding: 50px 20px;
        }
        h3{
            color: @font_primary;
            font-weight: 600;
            font-size: 24px;
            text-align: center;
            margin-bottom: 40px;
        }
        .help-container {
            max-width: 1200px;
            margin: 0 auto;
            .contact-button{
                max-width: 1000px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 24px;
                margin: 0 auto;
                @media @mobile{
                    flex-direction: column;
                    gap: 16px;
                }
                li{
                    background-color: @white;
                    color: @font_primary;
                    height: 100%;
                    width: 232px;
                    border-radius: @border-radius-level-button;
                    box-sizing: border-box;
                    cursor: pointer;
                    a{
                        color: @font_primary;
                        display:flex;
                        flex-direction: column;
                        gap: 8px;
                        padding: 20px;
                        height: 100%;
                        box-sizing: border-box;
                        text-align: center;
                        .help-icon {
                            font-size: 24px;
                            align-self: center;
                        }
                        p{
                            font-size: 16px;
                            font-weight: 500;
                        }
                    }
                    @media @pc{
                        &:hover{
                            a{
                                color: @theme;
                                p{
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                    @media @mobile{
                        width: 100%;
                    }

                }
            }
        }
    }

</style>
